import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/Index.vue'
Vue.use(Router)

window.addEventListener('popstate', () => {
    this.a.isBack = true
}, false)

export default new Router({
    routes: [
        {
            path: '/',
            component: Index,
            children: [
                {
                    path: 'login',
                    component: resolve => require(['../pages/login/index.vue'], resolve),
                    name: '登录',
                    meta:{
                        title:'登录'
                    }
                },
                {
                    path: 'activity/detail',
                    component: resolve => require(['../pages/activity/Detail.vue'], resolve),
                    name: '活动详情',
                    meta:{
                        title:'活动详情'
                    }
                },
                {
                    path: 'activity/fillInfo',
                    component: resolve => require(['../pages/activity/FillInfo.vue'], resolve),
                    name: '填写活动报名信息',
                    meta:{
                        title:'填写活动报名信息'
                    }
                },
                {
                    path: 'activity/order',
                    component: resolve => require(['../pages/activity/Order.vue'], resolve),
                    name: '微信订单详情',
                    meta:{
                        title:'微信订单详情'
                    }
                },
                {
                    path: 'activity/BrowserOrder',
                    component: resolve => require(['../pages/activity/BrowserOrder.vue'], resolve),
                    name: '活动订单详情',
                    meta:{
                        title:'活动订单详情'
                    }
                },
                {
                    path: 'activity/success',
                    component: resolve => require(['../pages/activity/PaySuccess.vue'], resolve),
                    name: '报名成功',
                    meta:{
                        title:'报名成功'
                    }
                },
                {
                    path: 'activity/group',
                    component: resolve => require(['../pages/activity/SignUpList.vue'], resolve),
                    name: '已报名列表',
                    meta:{
                        title:'已报名列表'
                    }
                },
                {
                    path: 'lessons/agentPay',
                    component: resolve => require(['../pages/lessons/AgentPay.vue'], resolve),
                    name: '代付课程',
                    meta:{
                        title:'代付课程'
                    }
                },
                {
                    path: 'lessons/BrowserOrder',
                    component: resolve => require(['../pages/lessons/BrowserOrder.vue'], resolve),
                    name: '课程订单详情',
                    meta:{
                        title:'课程订单详情'
                    }
                },
                {
                    path: 'lessons/PaySuccess',
                    component: resolve => require(['../pages/lessons/PaySuccess.vue'], resolve),
                    name: '购买成功',
                    meta:{
                        title:'购买成功'
                    }
                },
                {
                    path: 'lessons/share',
                    component: resolve => require(['../pages/lessons/Share.vue'], resolve),
                    name: '分享课程',
                    meta:{
                        title:'分享课程'
                    }
                },
                {
                    path: 'lessons/shareVideo',
                    component: resolve => require(['../pages/lessons/ShareVideo.vue'], resolve),
                    name: '分享课程视频',
                    meta:{
                        title:'分享课程视频'
                    }
                },
                {
                    path: 'lessons/shareDetail',
                    component: resolve => require(['../pages/lessons/ShareDetail.vue'], resolve),
                    name: '课程详情',
                    meta:{
                        title:'课程详情'
                    }
                },
                {
                    path: 'lessons/shareAudio',
                    component: resolve => require(['../pages/lessons/ShareAudio.vue'], resolve),
                    name: '分享课程音频',
                    meta:{
                        title:'分享课程音频'
                    }
                },
                {
                    path: 'lessons/imageText',
                    component: resolve => require(['../pages/lessons/imageText.vue'], resolve),
                    name: '图文课程',
                    meta:{
                        title:'图文课程'
                    }
                },
                {
                    path: 'artist/detail',
                    component: resolve => require(['../pages/artist/Detail.vue'], resolve),
                    name: '艺术家图文资料',
                    meta:{
                        title:'艺术家图文资料'
                    }
                },
                {
                    path: 'artist/about',
                    component: resolve => require(['../pages/artist/About.vue'], resolve),
                    name: '艺术家简介',
                    meta:{
                        title:'艺术家简介'
                    }
                },
                {
                    path: 'artist/shareVideo',
                    component: resolve => require(['../pages/artist/ShareVideo.vue'], resolve),
                    name: '艺术家视频分享',
                    meta:{
                        title:'艺术家视频分享'
                    }
                },
                {
                    path: 'artist/shareAudio',
                    component: resolve => require(['../pages/artist/ShareAudio.vue'], resolve),
                    name: '艺术家音频分享',
                    meta:{
                        title:'艺术家音频分享'
                    }
                },
                {
                    path: 'show/home',
                    component: resolve => require(['../pages/show/Home.vue'], resolve),
                    name: '才艺秀个人空间',
                    meta:{
                        title:'才艺秀个人空间'
                    }
                },
                {
                    path: 'show/shareVideo',
                    component: resolve => require(['../pages/show/ShareVideo.vue'], resolve),
                    name: '才艺秀视频分享',
                    meta:{
                        title:'才艺秀视频分享'
                    }
                },
                {
                    path: 'show/shareAudio',
                    component: resolve => require(['../pages/show/ShareAudio.vue'], resolve),
                    name: '才艺秀音频分享',
                    meta:{
                        title:'才艺秀音频分享'
                    }
                },
                {
                    path: 'coupon',
                    component: resolve => require(['../pages/coupon/index.vue'], resolve),
                    name: '领取优惠券',
                    meta:{
                        title:'领取优惠券'
                    }
                },
                {
                    path: 'coupon_h5',
                    component: resolve => require(['../pages/coupon/index_h5.vue'], resolve),
                    name: '兑换优惠券',
                    meta:{
                        title:'兑换优惠券'
                    }
                },
                {
                    path: 'coupon/bad',
                    component: resolve => require(['../pages/coupon/bad.vue'], resolve),
                    name: '领取失败',
                    meta:{
                        title:'领取失败'
                    }
                },
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js